import React from 'react';

import PageLayout from '../../components/PageLayout/PageLayout';

export const ClassUnderReviewPage = () => {
  const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_DASHBOARD_URL } = process.env;

  return (
    <div className="container container--space-y">
      <PageLayout
        title="The course you selected is currently in our review"
        helpText="We have saved your details so far and we will send you an email once the course is ready so you can continue your application."
      >
        <div className="mt-8">
          <a href={`${PLATFORM_DASHBOARD_URL}`} className="button niso-button close-button">
            Back to dashboard
          </a>
        </div>
      </PageLayout>
    </div>
  );
};

export default ClassUnderReviewPage;
